import React from 'react';

interface SubstackIconProps {
  size?: number;
  className?: string;
}

/**
 * Substack brand glyph — the official three-bar mark: two even top bars and a
 * lower panel with the signature triangular notch. Drawn to correct
 * proportions on a 24×24 grid so it renders crisply at any size. Monochrome via
 * `currentColor` so it inherits the surrounding text color and hover states.
 */
export const SubstackIcon: React.FC<SubstackIconProps> = ({ size = 20, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path d="M22.539 8.242H1.46V5.406h21.08v2.836zM1.46 10.812V24L12 18.11 22.54 24V10.812H1.46zM22.54 0H1.46v2.836h21.08V0z" />
  </svg>
);

export default SubstackIcon;
